import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import get from 'lodash/get';
import Ad from '../ad/ad';
import scrollToEl from '../../../utils/scroll_to_el_util';

export default class FranchiseIndexSection extends Component {
  constructor(props) {
    super(props);
    this.screenLarge = true;
  }

  componentDidUpdate() {
    scrollToEl(
      `.franchise-accordion-section--${this.props.activeSection}`,
      100
    );
  }

  render() {
    const {
      combinedAdModel,
      index,
      data,
      nextPage,
      prevPage,
      activeSection,
      propertyToDisplay,
      pathForSection,
      pathForData
    } = this.props;

    const nextStyle = {
      minHeight: 473
    };

    const dataList = get(data, 'rows') ? data.rows : null;
    const dataListSections = [];

    if (get(dataList, 'length')) {
      let i = 0;
      const chunk = 10;
      for (i; i < get(dataList, 'length'); i += chunk) {
        dataListSections.push(dataList.slice(i, i + chunk));
      }
    }
    return (
      <section
        className={`franchise-accordion-section franchise-accordion-section--${index}`}
        style={activeSection === index && this.screenLarge ? nextStyle : {}}
      >
        <Link
          to={
            activeSection === index
              ? `/${pathForSection}`
              : `/${pathForSection}/${index}/1`
          }
          className={`franchise-accordion-section__title-row franchise-accordion-section__title-row--${index}`}
          title={index}
        >
          <h2 className="franchise-accordion-section__title">{index}</h2>
          <img
            className={`franchise-accordion-section__title-icon
              ${
                activeSection === index
                  ? ' franchise-accordion-section__title-icon--active'
                  : ''
              }`}
            src="//images.fastcompany.net/image/upload/q_auto,fl_lossy/v1495723987/arrow-list-down-fix.svg"
            alt="arrow icon"
            title="arrow icon"
          />
        </Link>

        {get(dataListSections, 'length') && activeSection === index ? (
          <div className="franchise-accordion-section__list-container">
            {prevPage && this.screenLarge ? (
              <div className="franchise-accordion-section__prev-paddle">
                <Link
                  to={`/${pathForSection}/${index}/${prevPage}`}
                  title="Previous"
                >
                  <div className="franchise-accordion-section__prev-icon" />
                </Link>
              </div>
            ) : (
              ''
            )}
            <div className="franchise-accordion-section__list">
              {dataListSections.map(section => (
                <div
                  key={`${section[0][propertyToDisplay]}`}
                  className="franchise-accordion-section__list-column"
                >
                  {section.map(datum => (
                    <Link
                      to={`/${pathForData}/${datum.url}`}
                      key={datum[propertyToDisplay]}
                      title={datum[propertyToDisplay]}
                    >
                      {datum[propertyToDisplay]}
                    </Link>
                  ))}
                </div>
              ))}

              {!this.screenLarge && (prevPage || nextPage) ? (
                <ul className="pagination franchise-accordion-section__pagination">
                  <li
                    className={`pagination__page pagination__page--prev${
                      !prevPage
                        ? ' franchise-accordion-section__pagination-page--inactive'
                        : ''
                    }`}
                  >
                    {prevPage ? (
                      <Link
                        to={`/${pathForSection}/${index}/${prevPage}`}
                        title="Previous"
                      >
                        Prev
                      </Link>
                    ) : (
                      <span className="pagination__link">Prev</span>
                    )}
                  </li>
                  <li
                    className={`pagination__page pagination__page--next${
                      !nextPage
                        ? ' franchise-accordion-section__pagination-page--inactive'
                        : ''
                    }`}
                  >
                    {nextPage ? (
                      <Link
                        to={`/${pathForSection}/${index}/${nextPage}`}
                        title="Next"
                      >
                        Next
                      </Link>
                    ) : (
                      <span className="pagination__link">Next</span>
                    )}
                  </li>
                </ul>
              ) : (
                ''
              )}
            </div>

            {nextPage && this.screenLarge ? (
              <div className="franchise-accordion-section__next-paddle">
                <Link
                  to={`/${pathForSection}/${index}/${nextPage}`}
                  title="Next"
                >
                  <div className="franchise-accordion-section__next-icon" />
                </Link>
              </div>
            ) : (
              ''
            )}
          </div>
        ) : (
          ''
        )}

        {index === 'j' || index === 'z' ? (
          <div className="franchise-accordion-section__ff-ad-container">
            <Ad
              {...combinedAdModel}
              pos="btf"
              name="flexiblebillboard_1"
              noLazyLoad={true}
            />
            <Ad
              {...combinedAdModel}
              pos="btf"
              name="mobileparallax_1"
              noLazyLoad={true}
            />
          </div>
        ) : (
          ''
        )}
      </section>
    );
  }
}

FranchiseIndexSection.defaultProps = {
  nextPage: '',
  prevPage: '',
  activeSection: '',
  propertyToDisplay: '',
  pathForSection: '',
  pathForData: ''
};

FranchiseIndexSection.propTypes = {
  data: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  index: PropTypes.string.isRequired,
  nextPage: PropTypes.string,
  prevPage: PropTypes.string,
  activeSection: PropTypes.string,
  propertyToDisplay: PropTypes.string,
  pathForSection: PropTypes.string,
  pathForData: PropTypes.string
};
